import React from 'react'

const Gap = ({height, width}) => {
    return (
        <div style={{height: height, width: width}}>
            
        </div>
    )
}

export default Gap
